export enum FeatureKey {
  HOME_PAGE = "home_page",
  NEW_DASHBOARD = "new_dashboard",
  ENABLE_CHAT = "enable_chat",
  USER_VERTICAL = "user_vertical",
  APP_UPDATE_CONFIG = "app_update_config",
  /** AINA voice: disable mic when true (parity with ProConstants.AinaDisableMic). */
  AINA_DISABLE_MIC = "aina_disable_mic",
  /** AINA voice: disable doubts entry when true (ProConstants.AinaDisableDoubts). */
  AINA_DISABLE_DOUBTS = "aina_disable_doubts",
}
